export default {
  'users.user': 'User',
  'users.users': 'Users',
  'users.isntActivatedYet':
    "This user hasn't activated the aeroSUITE account yet.",
  'users.internal.title': 'Internal Users',
  'users.internal.newUserTitle': 'Add New User',
  'users.internal.popoverTitle': 'Complete profile to enable Send Invitation',
  'users.internal.sendInvitation': 'Send Invitation Email',
  'users.internal.requiredInfo':
    'required information submitted to Send an Invite',
  'users.internal.popoverContent':
    'First Name, Last Name, Email Address, Employee Number, Date of Join and Job Title are mandatory',
  'users.internal.updateInternalUser': 'Update Internal User',
  'users.internal.successInvite': 'Invitation email sent',
  'users.internal.successUpdate': 'User details updated',
  'users.internal.serviceUnavailable':
    'Service is temporarily unavailable, please try again later',
  'users.internal.failedUpdate': 'Sorry, could not update user at the moment.',
  'users.internal.cantUpdateUser':
    'Users with Invited/ Inactive status can not be updated',
  'users.internal.noEditPrivilege':
    'Users without Edit privilege can not be updated',
  'users.internal.noDeletePrivilege':
    'Users without Delete privilege can not be deleted',
  'users.internal.tabTitleUserDetails': 'User Details',
  'users.internal.tabTitleRoles': 'Role Management',
  'users.internal.tabTitleHistory': 'Session History',
  'users.internal.tabTitleAudit': 'Audit',
  'users.internal.tabTitleAuth': 'Authentication',
  'users.internal.unlockUser':
    'This user account was automatically locked due to multiple invalid login attempts. Do you want to enable access?',
  'users.internal.userDetailsValidationError':
    'Mandatory fields should not be empty',
  'users.internal.sessionStart': 'Session Start',
  'users.internal.sessionEnd': 'Session End',
  'users.internal.ipAddress': 'IP Address',
  'users.internal.duration': 'Duration',
  'users.internal.location': 'Location',
  'users.internal.applicationsAccessed': 'Applications Accessed',

  'users.external.title': 'External Users',
  'users.external.newUserTitle': 'New External User',
  'users.external.cantUpdateUser':
    'Users with Invited/Inactive status can not be updated',
  'users.external.noEditPrivilege':
    'Users without Edit privilege can not be updated',
  'users.external.noDeletePrivilege':
    'Users without Delete privilege can not be deleted',
  'users.external.updateExternalUser': 'Update External User',
  'users.external.userDetailsValidationError':
    'Mandatory fields should not be empty',
  'users.external.tabTitleUserDetails': 'User Details',
  'users.title.subcopy.panel.userLogInfo':
    'View Version History and Updates here',
  'userDetails.audit.changesMade': 'Changes Made',
  'userDetails.audit.modifiedOn': 'Modified On',
  'userDetails.audit.modifiedBy': 'Modified By',
  'userDetails.basicDetails.label': 'Basic Details',
  'users.activationSuccess': 'User Activation Successful',
  'users.activationFailed': 'User Activation Failed'
};
